import React, { useState, useEffect } from "react";
import loginImage01 from "../../../assets/images/registration/registration-steps-image-04.jpg";
import loginImage02 from "../../../assets/images/registration/registration-steps-image-05.jpg";
import loginImage03 from "../../../assets/images/registration/registration-steps-image-06.jpg";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { updateUserData } from "../../../Redux/userReducer";
import "react-toastify/dist/ReactToastify.css";
import { Endpoints } from "../../../Global/Endpoints";

const NotificationPreference = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const [appNotifications, setAppNotifications] = useState(
    contract.userData.NotificationStatus === "Yes"
  );
  const [textNotifications, setTextNotifications] = useState(
    contract.userData.TextNotificationStatus === "Yes"
  );

  useEffect(() => {
    setAppNotifications(contract.userData.NotificationStatus === "Yes");
    setTextNotifications(contract.userData.TextNotificationStatus === "Yes");
  }, [contract.userData]);

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
      new window.bootstrap.Carousel(myCarousel, {
        interval: 5000,
      });
    }
  }, []);

  const handleToggleChange = async (field) => {
    let newValue;
    let apiUrl;
    let updatedField;
    if (field === "app") {
      newValue = !appNotifications;
      setAppNotifications(newValue);
      apiUrl = Endpoints.SaveNotificationStatus;
      updatedField = "NotificationStatus";
    } else if (field === "text") {
      newValue = !textNotifications;
      setTextNotifications(newValue);
      apiUrl = Endpoints.SaveTextNotificationStatus;
      updatedField = "TextNotificationStatus";
    }

    const payload = {
      EmailID: contract.userData.EmailID,
      NotificationStatus: newValue ? "Yes" : "No",
      DeviceType:"PatientPortal"
    };

    try {
      const response = await axios.post(
        apiUrl,
        `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.Result === 1) {
        const updatedUserData = {
          ...contract.userData,
          [updatedField]: newValue ? "Yes" : "No",
        };
        dispatch(updateUserData(updatedUserData));
        toast.success(t("notificationpreferenceupdated"));
      } else {
        toast.error(response.data.Message || t("updatefailed"));

        // Revert state on failure
        if (field === "app") {
          setAppNotifications(!newValue);
        } else if (field === "text") {
          setTextNotifications(!newValue);
        }
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(t("erroroccuredupdatenotificationpreference"));

      // Revert state on error
      if (field === "app") {
        setAppNotifications(!newValue);
      } else if (field === "text") {
        setTextNotifications(!newValue);
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div
                className="carousel-item login-carousel-item active"
                data-bs-interval="5000"
              >
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div
                className="carousel-item login-carousel-item"
                data-bs-interval="5000"
              >
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div
                className="carousel-item login-carousel-item"
                data-bs-interval="5000"
              >
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-bold">{t("notificationpreference")}</h3>

            <div className="mt-5">
              <div className="mb-3 switch-control-wrapper">
                <label className="switch">
                  <input
                    type="checkbox"
                    className="switch-input"
                    checked={appNotifications}
                    onChange={() => handleToggleChange("app")}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="switch-label">{t("enableappnotifications")}</span>
              </div>
            </div>

            <div className="mt-5">
              <div className="mb-3 switch-control-wrapper">
                <label className="switch">
                  <input
                    type="checkbox"
                    className="switch-input"
                    checked={textNotifications}
                    onChange={() => handleToggleChange("text")}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="switch-label">{t("enabletextnotifications")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationPreference;
